import { BasketConfig } from '@domgen/dgx-fe-basket';
import { RegistrationRoutes } from '@registration/util-models';
import { AppConfig } from '../../models/config/app-config.type';

export const basketConfigFactory = (config: AppConfig): BasketConfig => ({
  basketApi: config.applianceLookupUrlBase,
  canRemoveSelectedQuotes: false,
  displayEmptyBasket: false,
  editQuoteRouterPath: RegistrationRoutes.ProtectionDetails,
  restartOnAllSelectedQuotesRemoved: false,
});
